import { render } from "./MetadataVariableComparability.vue?vue&type=template&id=108bf298"
import script from "./MetadataVariableComparability.vue?vue&type=script&lang=js"
export * from "./MetadataVariableComparability.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__